import libphonenumber from 'libphonenumber-js';

export function getGlobalHandle() {
  return window as any;
}

export const testMobileNumber = (number: string): boolean => {
  return libphonenumber(number)?.isValid() || false;
};

export const initialHelper = (fullName: string): string => {
  const names: string[] = fullName?.split(' ') || [];
  if (names.length === 0) {
    return '';
  }
  let initials = names[0].substring(0, 1);
  if (names.length > 1) {
    initials = initials + names[names.length - 1].substring(0, 1);
  } else {
    if (names[0].length > 1) {
      initials = names[0].substring(0, 2);
    }
  }
  return initials.toUpperCase();
};

export const validateEmail = (email: string): boolean => {
  const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return pattern.test(email);
};

export function capitalizeFirstLetter(string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function throttle(func: Function, rate: number) {
  let enabled = true;

  return function (arg?: any) {
    if (enabled) {
      func(arg);
      enabled = false;
      setTimeout(() => {
        enabled = true;
      }, rate);
    }
  };
}
